import React from 'react'

import * as UI from '@/src/shared/modules/form/ui/template.styled'

interface IProps extends React.PropsWithChildren, Omit<React.HTMLAttributes<HTMLElement>, 'title'> {
  title?: React.ReactNode
  className?: string
}

export const FormUI = UI

export const FormTemplate = ({title, children, ...props}: IProps) => (
  <UI.Wrapper {...props}>
    <UI.Form>
      {title && (
        <UI.Head>
          <UI.Title>{title}</UI.Title>
        </UI.Head>
      )}
      <UI.Container $haveTitle={!!title}>{children}</UI.Container>
    </UI.Form>
  </UI.Wrapper>
)

FormTemplate.__UI = {
  Wrapper: UI.Wrapper,
  Form: UI.Form,
  Container: UI.Container,
  Head: UI.Head,
  Title: UI.Title,
}
